import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "policy-page"
};
const _hoisted_2 = { class: "policy-card-container" };
const _hoisted_3 = {
    key: 0,
    class: "tabs"
};
const _hoisted_4 = {
    key: 1,
    class: "summary-content"
};
const _hoisted_5 = { class: "suggested-banner-group" };
const _hoisted_6 = { class: "suggested-banner" };
const _hoisted_7 = ["src"];
const _hoisted_8 = { class: "fields-list" };
const _hoisted_9 = { class: "suggested-field-label" };
const _hoisted_10 = { class: "suggested-field-value" };
const _hoisted_11 = {
    key: 1,
    class: "section-group"
};
const _hoisted_12 = { class: "fields-list" };
const _hoisted_13 = {
    key: 0,
    class: "field-card"
};
const _hoisted_14 = { class: "field-value" };
const _hoisted_15 = {
    key: 1,
    class: "field-card"
};
const _hoisted_16 = { class: "field-value" };
const _hoisted_17 = {
    key: 2,
    class: "field-card"
};
const _hoisted_18 = { class: "field-value" };
const _hoisted_19 = {
    key: 3,
    class: "field-card"
};
const _hoisted_20 = { class: "field-value" };
const _hoisted_21 = {
    key: 4,
    class: "field-card"
};
const _hoisted_22 = { class: "field-value" };
const _hoisted_23 = {
    key: 2,
    class: "section-group"
};
const _hoisted_24 = { class: "fields-list" };
const _hoisted_25 = {
    key: 0,
    class: "field-card"
};
const _hoisted_26 = { class: "field-value" };
const _hoisted_27 = {
    key: 1,
    class: "field-card"
};
const _hoisted_28 = { class: "field-value" };
const _hoisted_29 = {
    key: 0,
    class: "field-card"
};
const _hoisted_30 = { class: "field-value" };
const _hoisted_31 = {
    key: 1,
    class: "field-card"
};
const _hoisted_32 = { class: "field-value" };
const _hoisted_33 = {
    key: 2,
    class: "field-card"
};
const _hoisted_34 = { class: "field-value" };
const _hoisted_35 = {
    key: 0,
    class: "field-card"
};
const _hoisted_36 = { class: "field-value" };
const _hoisted_37 = {
    key: 1,
    class: "field-card"
};
const _hoisted_38 = { class: "field-value" };
const _hoisted_39 = {
    key: 3,
    class: "section-group"
};
const _hoisted_40 = { class: "fields-list" };
const _hoisted_41 = {
    key: 0,
    class: "field-card"
};
const _hoisted_42 = { class: "field-value" };
const _hoisted_43 = {
    key: 1,
    class: "field-card"
};
const _hoisted_44 = { class: "field-value" };
const _hoisted_45 = {
    key: 2,
    class: "field-card"
};
const _hoisted_46 = { class: "field-value" };
const _hoisted_47 = {
    key: 3,
    class: "field-card"
};
const _hoisted_48 = { class: "field-value" };
const _hoisted_49 = {
    key: 4,
    class: "field-card"
};
const _hoisted_50 = { class: "field-value" };
const _hoisted_51 = { class: "additional-header" };
const _hoisted_52 = {
    key: 0,
    class: "fields-list"
};
const _hoisted_53 = {
    key: 0,
    class: "field-card"
};
const _hoisted_54 = { class: "field-value" };
const _hoisted_55 = {
    key: 1,
    class: "field-card"
};
const _hoisted_56 = { class: "field-value" };
const _hoisted_57 = {
    key: 2,
    class: "field-card"
};
const _hoisted_58 = { class: "field-value" };
const _hoisted_59 = {
    key: 3,
    class: "field-card"
};
const _hoisted_60 = { class: "field-value" };
const _hoisted_61 = {
    key: 4,
    class: "field-card"
};
const _hoisted_62 = { class: "field-value" };
const _hoisted_63 = { class: "last-updated-row" };
const _hoisted_64 = {
    key: 0,
    class: "last-updated"
};
const _hoisted_65 = { class: "anchor-bottom-no-nav" };
const _hoisted_66 = {
    key: 2,
    class: "summary-content"
};
const _hoisted_67 = {
    key: 0,
    class: "linked-documents-list"
};
const _hoisted_68 = { class: "linked-document-info" };
const _hoisted_69 = { class: "linked-document-name" };
const _hoisted_70 = { class: "linked-document-date" };
const _hoisted_71 = ["href"];
const _hoisted_72 = {
    key: 1,
    class: "no-documents"
};
const _hoisted_73 = {
    key: 0,
    class: "documents-list"
};
const _hoisted_74 = ["href"];
const _hoisted_75 = {
    key: 1,
    class: "no-documents"
};
const _hoisted_76 = { key: 0 };
const _hoisted_77 = { key: 1 };
import { ref, computed, watch, onMounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuth } from '../composables/useAuth';
import { useAppState } from '../composables/useAppState';
import { useCustomer } from '../composables/useCustomer';
import { useInsurance } from '../composables/useInsurance';
import { useContent } from '../composables/useContent';
import { useDocuments } from '../composables/useDocuments';
import { useWhatsApp } from '../composables/useWhatsApp';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import AccountListItem from './elements/AccountListItem.vue';
import ProgressDial from './elements/ProgressDial.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
import MGDialog from './elements/MGDialog.vue';
import WhatsAppPromoCard from './elements/WhatsAppPromoCard.vue';
import WhatsAppEnableDrawer from './elements/WhatsAppEnableDrawer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PolicyPage',
    setup(__props) {
        useAuth();
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        const customerApi = useCustomer();
        const insurance = useInsurance();
        const content = useContent();
        const documentsApi = useDocuments();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        // Template refs for WhatsApp
        const whatsAppPromoCard = ref(null);
        const whatsAppEnableDrawer = ref(null);
        const whatsAppNumber = instance?.appContext.config.globalProperties.$whatsAppNumber || '';
        const { handleWhatsAppAction, handleEnableWhatsApp, handleWhatsAppEnableDone, handleWhatsAppDrawerClosed } = useWhatsApp({
            whatsAppPromoCard,
            whatsAppEnableDrawer,
            whatsAppNumber,
        });
        // Local state
        const activeTab = ref('summary');
        const editMode = ref(false);
        const showAdditional = ref(false);
        const showWhatsappCard = ref(true);
        const showDeleteConfirm = ref(false);
        const deleting = ref(false);
        const sections = ref([]);
        const policySections = ref([]);
        const coverSections = ref([]);
        const suggestedAsset = ref(null);
        // Aliases for template convenience
        const policy = computed(() => state.policy);
        const customer = computed(() => state.customer);
        const formatter = computed(() => state.formatter);
        const documents = computed(() => state.documents);
        // Computed
        const isBuildingsOrContents = computed(() => {
            const name = policy.value?.policyType?.name;
            return name === 'Contents' || name === 'Buildings' || name === 'Buildings & Contents';
        });
        const insuredAddress = computed(() => {
            const addr = policy.value?.insuredItems?.[0]?.addressInsured;
            if (!addr)
                return null;
            return [addr.line1, addr.line2, addr.postCode].filter(Boolean).join(', ');
        });
        const hasInsuredDetails = computed(() => {
            if (!policy.value?.insuredItems?.length)
                return false;
            const item = policy.value.insuredItems[0];
            const name = policy.value.policyType?.name;
            if (isBuildingsOrContents.value)
                return !!(item.addressInsured || item.valueInsured);
            if (name === 'Vehicle')
                return !!(item.vehicleMake || item.vehicleModel || item.vehicleRegistration);
            if (name === 'Pet')
                return !!(item.name || item.petBreed);
            return false;
        });
        const hasCoverDetails = computed(() => {
            return !!(policy.value?.annualPremium || policy.value?.monthlyPremium || policy.value?.sumAssured || policy.value?.excess || policy.value?.voluntaryExcess);
        });
        const hasAdditionalDetails = computed(() => {
            return !!(policy.value?.soleOrJoint || policy.value?.travelCoverType || policy.value?.travelCoverage || policy.value?.coverType || policy.value?.noClaimsYears);
        });
        const headerActionTop = computed(() => {
            const safeTop = parseInt(cookies?.get('st') ?? 0);
            return 16 + safeTop;
        });
        const isSuggested = computed(() => {
            return route.params.id === 'suggested';
        });
        const cardLabel = computed(() => {
            const ui = suggestedAsset.value?.uiElement;
            if (ui)
                return ui.rightTopValue ? ui.rightTopLabel : '';
            return policy.value?.endDate ? 'Renewal' : '';
        });
        const cardValue = computed(() => {
            const ui = suggestedAsset.value?.uiElement;
            if (ui)
                return ui.rightTopValue || '';
            return policy.value?.endDate ? formatDate(policy.value.endDate) : '';
        });
        const cardLabel2 = computed(() => {
            const ui = suggestedAsset.value?.uiElement;
            if (ui)
                return ui.rightBottomValue ? ui.rightBottomLabel : '';
            return '';
        });
        const cardValue2 = computed(() => {
            const ui = suggestedAsset.value?.uiElement;
            if (ui)
                return ui.rightBottomValue || '';
            return '';
        });
        const suggestedFields = computed(() => {
            if (!suggestedAsset.value)
                return [];
            const a = suggestedAsset.value;
            const fields = [];
            if (a.provider)
                fields.push({ label: 'Provider', value: a.provider });
            if (a.assetType)
                fields.push({ label: 'Type', value: a.assetType.replace(/([A-Z])/g, ' $1').trim() });
            if (a.accountNumber)
                fields.push({ label: 'Reference number', value: a.accountNumber });
            if (a.toDate)
                fields.push({ label: 'Renewal', value: formatDate(a.toDate) });
            if (a.balanceOrCost)
                fields.push({ label: 'Premium', value: formatter.value.format(parseFloat(a.balanceOrCost.replace(/[^0-9.-]/g, ''))) });
            if (a.registrationNumber)
                fields.push({ label: 'Vehicle registration', value: a.registrationNumber });
            if (a.address)
                fields.push({ label: 'Address', value: a.address });
            if (a.rate)
                fields.push({ label: 'Rate', value: a.rate });
            if (a.fromDate)
                fields.push({ label: 'Start date', value: formatDate(a.fromDate) });
            if (a.toDate)
                fields.push({ label: 'End date', value: formatDate(a.toDate) });
            if (a.termExpiry)
                fields.push({ label: 'Term expiry', value: formatDate(a.termExpiry) });
            return fields;
        });
        // Inlined helper methods
        function properCase(str) {
            if (!str)
                return str;
            return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
        }
        function formatDate(dateString) {
            if (!dateString)
                return '';
            let date;
            const parts = dateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
            if (parts) {
                date = new Date(parseInt(parts[3]), parseInt(parts[2]) - 1, parseInt(parts[1]));
            }
            else {
                date = new Date(dateString);
            }
            if (isNaN(date.getTime()))
                return dateString;
            return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
        }
        function getBrandLogoUrl(name) {
            const cleaned = name.toLowerCase()
                .replace(/\./g, '')
                .replace(/&/g, 'and')
                .replace(/[^a-z0-9 ]/g, '')
                .replace(/\s+/g, '-');
            return 'https://api.sysodev.link/BrandLogos/' + cleaned;
        }
        function dateToString(dateString) {
            if (!dateString)
                return '';
            const d = new Date(dateString);
            if (isNaN(d.getTime()))
                return dateString;
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            return `${day}/${month}/${year}`;
        }
        function stringToDate(dateString) {
            if (!dateString)
                return '';
            const parts = dateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
            if (!parts)
                return dateString;
            return `${parts[3]}-${parts[2].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
        }
        function findFieldById(fieldId) {
            return findFieldByIdInSections(sections.value, fieldId);
        }
        function findFieldByIdInSections(sectionsArr, fieldId) {
            for (const section of sectionsArr) {
                if (!section.fields)
                    continue;
                for (const field of section.fields) {
                    if (field.id === fieldId)
                        return field;
                }
            }
            return null;
        }
        function findFieldValueByIdInSections(sectionsArr, fieldId) {
            const field = findFieldByIdInSections(sectionsArr, fieldId);
            return field ? field.value : null;
        }
        function filterSectionsByRule(sectionsArr, ruleKey, ruleValue) {
            return sectionsArr.filter((section) => {
                if (!section.rules || section.rules.length === 0)
                    return true;
                return section.rules.some((rule) => rule.key === ruleKey && rule.value === ruleValue);
            });
        }
        // Methods
        function handleHeaderDelete(done) {
            insurance.deletePolicy(route.params.id, () => {
                insurance.getInsuranceInfo(null, true);
                if (done)
                    done();
                router.push('/money');
            });
        }
        function loadEditSections() {
            content.getAiopSection('InsuranceAdditionalSection.json', () => {
                sections.value = state.sectionJson;
                insurance.getInsuranceProviders((res) => {
                    res = res.filter((item) => item.buildings === true || item.contents === true || item.gadget === true
                        || item.car === true || item.motorbike === true || item.pet === true
                        || item.life === true || item.other === true)
                        .filter((item, index, self) => index === self.findIndex((t) => t.name === item.name));
                    const providerField = findFieldById('provider');
                    if (providerField) {
                        providerField.items = res.map((provider) => ({
                            name: provider.name.replace(/\w\S*/g, (txt) => {
                                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                            }),
                            logoUri: provider.logoUri
                        }));
                    }
                });
                content.getAiopSection('InsuranceAdditionalAbout.json', () => {
                    const aboutSections = state.sectionJson;
                    content.getAiopSection('InsuranceAdditionalCover.json', () => {
                        const coverSectionsJson = state.sectionJson;
                        const policyType = policy.value?.policyType?.name;
                        policySections.value = filterSectionsByRule(aboutSections, 'policyType', policyType);
                        coverSections.value = filterSectionsByRule(coverSectionsJson, 'policyType', policyType);
                        populateFields(sections.value);
                        populateFields(policySections.value);
                        populateFields(coverSections.value);
                        editMode.value = true;
                    });
                });
            });
        }
        function populateFields(sectionsArr) {
            if (!policy.value)
                return;
            const providerField = findFieldByIdInSections(sectionsArr, 'provider');
            if (providerField)
                providerField.value = policy.value.provider?.name || '';
            const renewalDateField = findFieldByIdInSections(sectionsArr, 'renewalDate');
            if (renewalDateField)
                renewalDateField.value = dateToString(policy.value.endDate);
            const startDateField = findFieldByIdInSections(sectionsArr, 'startDate');
            if (startDateField)
                startDateField.value = dateToString(policy.value.startDate);
            const payFrequencyField = findFieldByIdInSections(sectionsArr, 'payFrequency');
            if (payFrequencyField) {
                payFrequencyField.value = policy.value.payFrequency || (policy.value.annualPremium ? 'Annually' : policy.value.monthlyPremium ? 'Monthly' : null);
            }
            const policyNumberField = findFieldByIdInSections(sectionsArr, 'policyNumber');
            if (policyNumberField)
                policyNumberField.value = policy.value.policyNumber || null;
            const premiumField = findFieldByIdInSections(sectionsArr, 'premium');
            if (premiumField)
                premiumField.value = policy.value.annualPremium || policy.value.monthlyPremium || null;
            const excessField = findFieldByIdInSections(sectionsArr, 'excess');
            if (excessField)
                excessField.value = policy.value.excess || null;
            const voluntaryExcessField = findFieldByIdInSections(sectionsArr, 'voluntaryExcess');
            if (voluntaryExcessField)
                voluntaryExcessField.value = policy.value.voluntaryExcess || null;
            const sumInsuredField = findFieldByIdInSections(sectionsArr, 'sumInsured');
            if (sumInsuredField)
                sumInsuredField.value = policy.value.sumAssured || null;
            const addressField = findFieldByIdInSections(sectionsArr, 'address');
            if (addressField && policy.value.insuredItems?.[0]?.addressInsured) {
                addressField.value = policy.value.insuredItems[0].addressInsured;
            }
        }
        function findFieldValueInAllSections(fieldId) {
            const allSections = [...sections.value, ...policySections.value, ...coverSections.value];
            return findFieldValueByIdInSections(allSections, fieldId);
        }
        function saveChanges() {
            const payFrequency = findFieldValueInAllSections('payFrequency');
            const policyNumber = findFieldValueInAllSections('policyNumber');
            const premium = findFieldValueInAllSections('premium');
            const excess = findFieldValueInAllSections('excess');
            const voluntaryExcess = findFieldValueInAllSections('voluntaryExcess');
            const totalExcess = (parseFloat(excess) || 0) + (parseFloat(voluntaryExcess) || 0);
            const sumInsured = findFieldValueInAllSections('sumInsured');
            const addressObject = findFieldValueInAllSections('address');
            let insuredItems = policy.value.insuredItems;
            if (addressObject && insuredItems && insuredItems.length > 0) {
                insuredItems[0].addressInsured = {
                    line1: addressObject?.line1 || null,
                    line2: addressObject?.line2 || null,
                    line3: addressObject?.line3 || null,
                    town: addressObject?.town || null,
                    postCode: addressObject?.postCode || null,
                };
            }
            const renewalDate = findFieldValueInAllSections('renewalDate');
            const startDate = findFieldValueInAllSections('startDate');
            const updatedPolicy = {
                id: route.params.id,
                policyType: policy.value.policyType,
                provider: policy.value.provider,
                insuredItems: insuredItems,
                startDate: startDate ? stringToDate(startDate) : policy.value.startDate,
                endDate: renewalDate ? stringToDate(renewalDate) : policy.value.endDate,
                payFrequency: payFrequency || null,
                policyNumber: policyNumber || null,
                annualPremium: payFrequency === 'Annually' ? premium : null,
                monthlyPremium: payFrequency === 'Monthly' ? premium : null,
                excess: totalExcess || policy.value.excess,
                voluntaryExcess: voluntaryExcess || policy.value.voluntaryExcess,
                noClaimsYears: policy.value.noClaimsYears,
                soleOrJoint: policy.value.soleOrJoint,
                sumAssured: sumInsured || policy.value.sumAssured,
                coverType: policy.value.coverType,
                travelCoverType: policy.value.travelCoverType,
                travelCoverage: policy.value.travelCoverage
            };
            insurance.updatePolicy(updatedPolicy, () => {
                insurance.getPolicy(route.params.id, null, true);
                insurance.getInsuranceInfo(null, true);
                editMode.value = false;
            });
        }
        function confirmDelete() {
            deleting.value = true;
            if (isSuggested.value && suggestedAsset.value?.relatedDocuments?.length) {
                let remaining = suggestedAsset.value.relatedDocuments.length;
                suggestedAsset.value.relatedDocuments.forEach((doc) => {
                    documentsApi.deleteDocument(doc.id, () => {
                        remaining--;
                        if (remaining === 0) {
                            documentsApi.clearDocuments();
                            router.push('/money');
                        }
                    });
                });
            }
            else {
                insurance.deletePolicy(route.params.id, () => {
                    insurance.getInsuranceInfo(null, true);
                    router.push('/money');
                });
            }
        }
        function onLoad() {
            customerApi.getCustomer();
            if (isSuggested.value) {
                const assetId = route.query.assetId;
                if (assetId) {
                    content.getSuggestedAssets((result) => {
                        const asset = result.find((a) => a.id === assetId);
                        if (asset) {
                            suggestedAsset.value = asset;
                            const a = suggestedAsset.value;
                            state.policy = {
                                provider: { name: a.provider || 'Provider' },
                                policyType: { name: a.assetType ? a.assetType.replace(/([A-Z])/g, ' $1').trim() : 'Insurance' },
                                policyNumber: a.accountNumber || '',
                                endDate: a.toDate || null,
                                startDate: a.fromDate || null
                            };
                        }
                        else {
                            router.push('/money');
                        }
                    });
                }
                else {
                    router.push('/money');
                }
            }
            else {
                insurance.getPolicy(route.params.id, () => {
                    documentsApi.getDocumentsByHubId(state.policy.id);
                });
            }
        }
        // Watch
        watch(activeTab, (val) => {
            const hash = window.location.hash.split('?')[0];
            const params = new URLSearchParams(window.location.hash.split('?')[1] || '');
            params.set('tab', val);
            const newUrl = window.location.pathname + window.location.search + hash + '?' + params.toString();
            window.history.replaceState(history.state, '', newUrl);
        });
        // Mounted
        onMounted(() => {
            const tab = route.query.tab;
            if (tab === 'summary' || tab === 'documents') {
                activeTab.value = tab;
            }
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: isSuggested.value ? 'View policy' : 'Your policy',
                    border: "0",
                    edit: !isSuggested.value && !editMode.value,
                    del: !isSuggested.value && !editMode.value,
                    onEdit: loadEditSections,
                    onDelete: handleHeaderDelete,
                    menuDescription: "Would you like to edit or delete this policy?"
                }, null, 8, ["title", "edit", "del"]),
                _createVNode(CustomerLoadWait, { customer: policy.value }, null, 8, ["customer"]),
                (policy.value && !isSuggested.value && editMode.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "header-action-btn",
                        style: _normalizeStyle('top: ' + headerActionTop.value + 'px;'),
                        onClick: _cache[0] || (_cache[0] = ($event) => (editMode.value = false))
                    }, [
                        _createVNode(_component_v_icon, {
                            icon: "mdi-close",
                            size: "20"
                        })
                    ], 4))
                    : _createCommentVNode("", true),
                (policy.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(AccountListItem, {
                                "provider-name": properCase(policy.value.provider?.name) || 'Provider',
                                line1: policy.value.policyType?.name || 'Insurance',
                                line2: policy.value.policyNumber || '',
                                label: cardLabel.value,
                                value: cardValue.value,
                                label2: cardLabel2.value,
                                value2: cardValue2.value,
                                "avatar-url": policy.value.provider?.name ? getBrandLogoUrl(policy.value.provider.name) : require('@/assets/round1.png'),
                                "badge-url": isSuggested.value ? require('@/assets/aisummary.png') : null
                            }, null, 8, ["provider-name", "line1", "line2", "label", "value", "label2", "value2", "avatar-url", "badge-url"])
                        ]),
                        (isSuggested.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["tab", { active: activeTab.value === 'summary' }]),
                                    onClick: _cache[1] || (_cache[1] = ($event) => (activeTab.value = 'summary'))
                                }, "Details", 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["tab", { active: activeTab.value === 'documents' }]),
                                    onClick: _cache[2] || (_cache[2] = ($event) => (activeTab.value = 'documents'))
                                }, "Documents", 2)
                            ]))
                            : _createCommentVNode("", true),
                        (activeTab.value === 'summary')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                (isSuggested.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("img", {
                                                    src: require('@/assets/aisummary-noborder.png'),
                                                    class: "suggested-banner-icon"
                                                }, null, 8, _hoisted_7),
                                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "suggested-banner-text" }, "Added from your documents", -1))
                                            ]),
                                            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "suggested-banner-description" }, [
                                                _createTextVNode("This policy was automatically created from files you uploaded. Manage it in "),
                                                _createElementVNode("a", {
                                                    href: "/#/documents",
                                                    class: "suggested-link"
                                                }, "My Documents"),
                                                _createTextVNode(".")
                                            ], -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_8, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestedFields.value, (field) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    class: "suggested-field-card",
                                                    key: field.label
                                                }, [
                                                    _createElementVNode("span", _hoisted_9, _toDisplayString(properCase(field.label)), 1),
                                                    _createElementVNode("span", _hoisted_10, _toDisplayString(properCase(field.value)), 1)
                                                ]));
                                            }), 128))
                                        ])
                                    ], 64))
                                    : _createCommentVNode("", true),
                                (!editMode.value && !isSuggested.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (policy.value.startDate && policy.value.endDate)
                                            ? (_openBlock(), _createBlock(ProgressDial, {
                                                key: 0,
                                                fromDate: policy.value.startDate,
                                                toDate: policy.value.endDate,
                                                title: "Days until renewal",
                                                footerLabel: "Renewal date"
                                            }, null, 8, ["fromDate", "toDate"]))
                                            : _createCommentVNode("", true),
                                        (policy.value.policyType?.name || policy.value.provider?.name || policy.value.startDate || policy.value.payFrequency || policy.value.policyNumber)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "section-title" }, "Policy details", -1)),
                                                _createElementVNode("div", _hoisted_12, [
                                                    (policy.value.policyType?.name)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "field-label" }, "Type", -1)),
                                                            _createElementVNode("span", _hoisted_14, _toDisplayString(policy.value.policyType.name), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (policy.value.provider?.name)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "field-label" }, "Provider", -1)),
                                                            _createElementVNode("span", _hoisted_16, _toDisplayString(properCase(policy.value.provider.name)), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (policy.value.startDate)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "field-label" }, "Start date", -1)),
                                                            _createElementVNode("span", _hoisted_18, _toDisplayString(formatDate(policy.value.startDate)), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (policy.value.payFrequency)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "field-label" }, "Pay frequency", -1)),
                                                            _createElementVNode("span", _hoisted_20, _toDisplayString(policy.value.payFrequency), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (policy.value.policyNumber)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "field-label" }, "Policy number", -1)),
                                                            _createElementVNode("span", _hoisted_22, _toDisplayString(policy.value.policyNumber), 1)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (hasInsuredDetails.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                _cache[23] || (_cache[23] = _createElementVNode("h2", { class: "section-title" }, "What's insured", -1)),
                                                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "section-subtitle" }, "The home, person, pet, or thing this policy is for", -1)),
                                                _createElementVNode("div", _hoisted_24, [
                                                    (isBuildingsOrContents.value)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            (insuredAddress.value)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "field-label" }, "Property address", -1)),
                                                                    _createElementVNode("span", _hoisted_26, _toDisplayString(insuredAddress.value), 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (policy.value.insuredItems[0]?.valueInsured)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "field-label" }, "Value insured", -1)),
                                                                    _createElementVNode("span", _hoisted_28, _toDisplayString(formatter.value.format(policy.value.insuredItems[0].valueInsured)), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ], 64))
                                                        : _createCommentVNode("", true),
                                                    (policy.value.policyType?.name === 'Vehicle')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            (policy.value.insuredItems[0]?.vehicleMake)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "field-label" }, "Make", -1)),
                                                                    _createElementVNode("span", _hoisted_30, _toDisplayString(policy.value.insuredItems[0].vehicleMake), 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (policy.value.insuredItems[0]?.vehicleModel)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                                    _cache[19] || (_cache[19] = _createElementVNode("span", { class: "field-label" }, "Model", -1)),
                                                                    _createElementVNode("span", _hoisted_32, _toDisplayString(policy.value.insuredItems[0].vehicleModel), 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (policy.value.insuredItems[0]?.vehicleRegistration)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "field-label" }, "Registration", -1)),
                                                                    _createElementVNode("span", _hoisted_34, _toDisplayString(policy.value.insuredItems[0].vehicleRegistration), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ], 64))
                                                        : _createCommentVNode("", true),
                                                    (policy.value.policyType?.name === 'Pet')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                            (policy.value.insuredItems[0]?.name)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "field-label" }, "Name", -1)),
                                                                    _createElementVNode("span", _hoisted_36, _toDisplayString(policy.value.insuredItems[0].name), 1)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (policy.value.insuredItems[0]?.petBreed)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "field-label" }, "Breed", -1)),
                                                                    _createElementVNode("span", _hoisted_38, _toDisplayString(policy.value.insuredItems[0].petBreed), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ], 64))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (hasCoverDetails.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                _cache[30] || (_cache[30] = _createElementVNode("h2", { class: "section-title" }, "Cover & limits", -1)),
                                                _cache[31] || (_cache[31] = _createElementVNode("p", { class: "section-subtitle" }, "What's covered and where the limits apply", -1)),
                                                _createElementVNode("div", _hoisted_40, [
                                                    (policy.value.annualPremium)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                            _cache[25] || (_cache[25] = _createElementVNode("span", { class: "field-label" }, "Annual premium", -1)),
                                                            _createElementVNode("span", _hoisted_42, _toDisplayString(formatter.value.format(policy.value.annualPremium)), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (policy.value.monthlyPremium)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                            _cache[26] || (_cache[26] = _createElementVNode("span", { class: "field-label" }, "Monthly premium", -1)),
                                                            _createElementVNode("span", _hoisted_44, _toDisplayString(formatter.value.format(policy.value.monthlyPremium)), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (policy.value.sumAssured)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "field-label" }, "Sum insured", -1)),
                                                            _createElementVNode("span", _hoisted_46, _toDisplayString(formatter.value.format(policy.value.sumAssured)), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (policy.value.excess)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "field-label" }, "Excess", -1)),
                                                            _createElementVNode("span", _hoisted_48, _toDisplayString(formatter.value.format(policy.value.excess)), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (policy.value.voluntaryExcess)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "field-label" }, "Voluntary excess", -1)),
                                                            _createElementVNode("span", _hoisted_50, _toDisplayString(formatter.value.format(policy.value.voluntaryExcess)), 1)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (hasAdditionalDetails.value)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 4,
                                                class: "additional-section",
                                                onClick: _cache[3] || (_cache[3] = ($event) => (showAdditional.value = !showAdditional.value))
                                            }, [
                                                _createElementVNode("div", _hoisted_51, [
                                                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "section-title" }, "Additional details", -1)),
                                                    _createVNode(_component_v_icon, {
                                                        icon: showAdditional.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                                                        size: "16"
                                                    }, null, 8, ["icon"])
                                                ]),
                                                (showAdditional.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                        (policy.value.soleOrJoint)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "field-label" }, "Sole or joint", -1)),
                                                                _createElementVNode("span", _hoisted_54, _toDisplayString(policy.value.soleOrJoint), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (policy.value.coverType)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "field-label" }, "Cover type", -1)),
                                                                _createElementVNode("span", _hoisted_56, _toDisplayString(policy.value.coverType), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (policy.value.noClaimsYears)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "field-label" }, "No claims (years)", -1)),
                                                                _createElementVNode("span", _hoisted_58, _toDisplayString(policy.value.noClaimsYears), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (policy.value.travelCoverType)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "field-label" }, "Travel cover type", -1)),
                                                                _createElementVNode("span", _hoisted_60, _toDisplayString(policy.value.travelCoverType), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (policy.value.travelCoverage)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "field-label" }, "Travel coverage", -1)),
                                                                _createElementVNode("span", _hoisted_62, _toDisplayString(policy.value.travelCoverage), 1)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (showWhatsappCard.value)
                                            ? (_openBlock(), _createBlock(WhatsAppPromoCard, {
                                                key: 5,
                                                ref_key: "whatsAppPromoCard",
                                                ref: whatsAppPromoCard,
                                                title: "Questions about your policy?",
                                                subtitle: "Chat with our WhatsApp assistant about this policy or send us documents.",
                                                buttonText: "Chat on WhatsApp",
                                                closable: true,
                                                onClose: _cache[4] || (_cache[4] = ($event) => (showWhatsappCard.value = false)),
                                                onAction: _unref(handleWhatsAppAction)
                                            }, null, 8, ["onAction"]))
                                            : _createCommentVNode("", true),
                                        _createVNode(MGButton, {
                                            text: "Delete policy",
                                            fullWidth: true,
                                            arrow: true,
                                            onClick: _cache[5] || (_cache[5] = ($event) => (showDeleteConfirm.value = true))
                                        }),
                                        _createElementVNode("div", _hoisted_63, [
                                            (policy.value.lastUpdatedDateTime)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_64, "Last updated: " + _toDisplayString(formatDate(policy.value.lastUpdatedDateTime)) + ".", 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 64))
                                    : _createCommentVNode("", true),
                                (editMode.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _cache[38] || (_cache[38] = _createElementVNode("h2", { class: "section-title" }, "Policy details", -1)),
                                        (sections.value.length)
                                            ? (_openBlock(), _createBlock(InputSections, {
                                                key: 0,
                                                ref: "inputSections",
                                                sections: sections.value,
                                                formatter: formatter.value,
                                                theme: "light",
                                                editMode: true,
                                                outline: false
                                            }, null, 8, ["sections", "formatter"]))
                                            : _createCommentVNode("", true),
                                        _cache[39] || (_cache[39] = _createElementVNode("h2", { class: "section-title" }, "What's insured", -1)),
                                        _cache[40] || (_cache[40] = _createElementVNode("p", { class: "section-subtitle" }, "The home, person, pet, or thing this policy is for", -1)),
                                        (policySections.value.length)
                                            ? (_openBlock(), _createBlock(InputSections, {
                                                key: 1,
                                                ref: "policySectionsInput",
                                                sections: policySections.value,
                                                formatter: formatter.value,
                                                theme: "light",
                                                editMode: true,
                                                outline: false
                                            }, null, 8, ["sections", "formatter"]))
                                            : _createCommentVNode("", true),
                                        _cache[41] || (_cache[41] = _createElementVNode("h2", { class: "section-title" }, "Cover & limits", -1)),
                                        _cache[42] || (_cache[42] = _createElementVNode("p", { class: "section-subtitle" }, "What's covered and where the limits apply", -1)),
                                        (coverSections.value.length)
                                            ? (_openBlock(), _createBlock(InputSections, {
                                                key: 2,
                                                ref: "coverSectionsInput",
                                                sections: coverSections.value,
                                                formatter: formatter.value,
                                                theme: "light",
                                                editMode: true,
                                                outline: false
                                            }, null, 8, ["sections", "formatter"]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_65, [
                                            _createVNode(MGButton, {
                                                text: "Save changes",
                                                fullWidth: true,
                                                onClick: saveChanges
                                            })
                                        ])
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        (activeTab.value === 'documents')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                (isSuggested.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "linked-documents-header" }, [
                                            _createElementVNode("p", { class: "linked-documents-title" }, "Linked documents"),
                                            _createElementVNode("p", { class: "linked-documents-subtitle" }, "Documents that were used to create this policy.")
                                        ], -1)),
                                        (suggestedAsset.value?.relatedDocuments?.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestedAsset.value.relatedDocuments, (doc) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: doc.id,
                                                        class: "linked-document-item"
                                                    }, [
                                                        _createElementVNode("div", _hoisted_68, [
                                                            _createElementVNode("p", _hoisted_69, _toDisplayString(doc.documentSubject || 'Document'), 1),
                                                            _createElementVNode("p", _hoisted_70, _toDisplayString(doc.createDateTimeString || ''), 1)
                                                        ]),
                                                        _createElementVNode("a", {
                                                            href: '/#/documents/' + doc.id,
                                                            class: "linked-document-view"
                                                        }, "View", 8, _hoisted_71)
                                                    ]));
                                                }), 128))
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_72, _cache[43] || (_cache[43] = [
                                                _createElementVNode("p", null, "No documents linked to this policy.", -1)
                                            ]))),
                                        _createVNode(WhatsAppPromoCard, {
                                            ref: "whatsAppPromoCardDocs",
                                            showImage: true,
                                            title: "Send a document or photo",
                                            subtitle: "We'll add the key details and save the document securely. You can also chat with our WhatsApp assistant.",
                                            closable: false,
                                            onAction: _unref(handleWhatsAppAction)
                                        }, null, 8, ["onAction"])
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (documents.value && documents.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value, (d) => {
                                                    return (_openBlock(), _createElementBlock("a", {
                                                        key: d.id,
                                                        href: d.url,
                                                        class: "document-item"
                                                    }, [
                                                        _createVNode(AccountListItem, {
                                                            "provider-name": d.name || 'Document',
                                                            line1: d.createDateTimeString || '',
                                                            line2: "",
                                                            value: "",
                                                            label: "",
                                                            "avatar-url": require('@/assets/round1.png')
                                                        }, null, 8, ["provider-name", "line1", "avatar-url"])
                                                    ], 8, _hoisted_74));
                                                }), 128))
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                                _cache[45] || (_cache[45] = _createElementVNode("p", null, "No documents linked to this policy yet.", -1)),
                                                _createVNode(WhatsAppPromoCard, {
                                                    ref: "whatsAppPromoCardDocs",
                                                    title: "Send a document or photo",
                                                    subtitle: "We'll add the key details and save the document securely. You can also chat with our WhatsApp assistant.",
                                                    closable: false,
                                                    onAction: _unref(handleWhatsAppAction)
                                                }, null, 8, ["onAction"])
                                            ]))
                                    ], 64))
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(MGDialog, {
                    modelValue: showDeleteConfirm.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((showDeleteConfirm).value = $event)),
                    title: "Delete policy",
                    maxWidth: "500px",
                    contentHeight: "auto",
                    persistent: false
                }, {
                    content: _withCtx(() => [
                        (isSuggested.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_76, "This will delete any documents you uploaded for this policy. This operation cannot be undone."))
                            : (_openBlock(), _createElementBlock("p", _hoisted_77, "Are you sure you want to delete this policy? This action cannot be undone."))
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            fullWidth: true,
                            onClick: confirmDelete,
                            text: deleting.value ? 'Deleting...' : 'Delete',
                            disabled: deleting.value
                        }, null, 8, ["text", "disabled"]),
                        _createVNode(MGButton, {
                            stacked: true,
                            fullWidth: true,
                            onClick: _cache[6] || (_cache[6] = ($event) => (showDeleteConfirm.value = false)),
                            outline: true,
                            text: "Cancel",
                            disabled: deleting.value
                        }, null, 8, ["disabled"])
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(WhatsAppEnableDrawer, {
                    ref_key: "whatsAppEnableDrawer",
                    ref: whatsAppEnableDrawer,
                    phoneNumber: customer.value?.person?.mobilePhone || '',
                    onEnable: _unref(handleEnableWhatsApp),
                    onDone: _unref(handleWhatsAppEnableDone),
                    onClosed: _unref(handleWhatsAppDrawerClosed)
                }, null, 8, ["phoneNumber", "onEnable", "onDone", "onClosed"])
            ], 64));
        };
    }
});
